import { Directions, RemoveRedEye } from "@mui/icons-material";
import { Box, CloseIcon, Default_Text_Color, SummaryTable, Typography, useState } from "../../utils/globalImports";
import { InfoCard } from "./SummaryCard";
import { Icon } from "@mui/material";
import Dashboard from "@mui/icons-material/Dashboard";
import Home from "@mui/icons-material/Home";
import Settings from "@mui/icons-material/Settings";
import Menu from "@mui/icons-material/Menu";
import Search from "@mui/icons-material/Search";
import Notifications from "@mui/icons-material/Notifications";
import Person from "@mui/icons-material/Person";
import AccountCircle from "@mui/icons-material/AccountCircle";
import Group from "@mui/icons-material/Group";
import Login from "@mui/icons-material/Login";
import Logout from "@mui/icons-material/Logout";
import Email from "@mui/icons-material/Email";
import Call from "@mui/icons-material/Call";
import Chat from "@mui/icons-material/Chat";
import Message from "@mui/icons-material/Message";
import Send from "@mui/icons-material/Send";
import TaskIcon from '@mui/icons-material/Task';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';


interface ProjectSummaryProps {
    data: any;
    heading: string;
    subHeading?: string;
}

const ProjectSummaryComponent = ({ data, heading, subHeading }: ProjectSummaryProps) => {
    const colors = [
        { subColor: "#eef2ff", color: "#3949ab" },
        { subColor: "#e6f4ea", color: "#2e7d32" },
        { subColor: "#e3f2fd", color: "#1565c0" },
        { subColor: "#fff3e0", color: "#ef6c00" },
        { subColor: "#ede7f6", color: "#5e35b1" },
        { subColor: "#fce4ec", color: "#c2185b" },
        { subColor: "#f7dbdb", color: "#e70b12" },
    ];
    const iconMapping = {
        Dashboard,
        Home,
        Settings,
        Menu,
        Search,
        Notifications,
        Person,
        AccountCircle,
        Group,
        Login,
        Logout,
        Email,
        Call,
        Chat,
        Message,
        Send
    };

    return (
        <div>
            <Box
                display="flex"
                alignItems="center"
                mb={3}
            >
                <Box
                    sx={{
                        width: 48,
                        height: 48,
                        borderRadius: 2,
                        backgroundColor: "#EFF6FF",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                    }}
                >
                    <Icon component={DescriptionOutlinedIcon} sx={{ fontSize: 24, color: "#3B82F6" }} />
                </Box>

                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        ml: 3
                    }}
                >
                    <Typography
                        variant="h5"
                        sx={{
                            fontWeight: 600,
                        }}
                    >
                        {heading}
                    </Typography>
                    <Typography
                        component={'p'}
                        sx={{
                            fontWeight: 300,

                        }}
                    >
                        {subHeading}
                    </Typography>
                </Box>
            </Box>
            <Box
                sx={{
                    display: "flex",
                    flexDirection:"column",
                    gap: 2,
                }}
            >
                <InfoCard
                    icon={RemoveRedEye}
                    description="Name"
                    value="Amount"
                />
                {data.map((item: any, index: number) => {
                    const color = colors[index % colors.length];
                    const IconComponent =
                        iconMapping[item.icon as keyof typeof iconMapping];
                    return (
                        <Box
                            key={index}
                            sx={{
                                display: "flex",
                            }}
                        >
                            <InfoCard
                                icon={IconComponent}
                                description={item.description}
                                value={item.value}
                                iconColor={color.color}
                                valueColor={color.color}
                                iconBgColor={color.subColor}
                            />
                        </Box>
                    );
                })}
            </Box>
        </div>
    )
}

export default ProjectSummaryComponent